// hooks/useAutoTimeout.js
import { useState, useEffect } from "react";
import SessionContext from "../App/SessionContext";

export const useAutoTimeout = (startTimeSeconds, onTimeout) => {
    const [timer, setTimer] = useState(startTimeSeconds);

    useEffect(() => {
        // Initialize / reset logoutTime
        const setLogoutTime = () => {
            const logoutAt = Date.now() + startTimeSeconds * 1000;
            SessionContext.set("logoutTime", logoutAt);
        };

        if (!SessionContext.get("logoutTime")) {
            setLogoutTime();
        }

        const events = ["load", "mousedown", "click", "scroll", "keypress"];

        const resetTimeout = () => {
            setLogoutTime();
        };

        events.forEach(evt => {
            window.addEventListener(evt, resetTimeout);
        });

        const intervalId = setInterval(() => {
            const logoutTime = SessionContext.get("logoutTime");

            if (!logoutTime) {
                return;
            }

            const remainingMs = logoutTime - Date.now();
            const remainingSeconds = Math.max(
                0,
                Math.floor(remainingMs / 1000)
            );

            setTimer(remainingSeconds);

            if (remainingSeconds === 0) {
                clearInterval(intervalId);
                if (onTimeout) {
                    onTimeout();
                }
            }
        }, 1000);

        return () => {
            clearInterval(intervalId);
            events.forEach(evt => {
                window.removeEventListener(evt, resetTimeout);
            });
        };
    }, [startTimeSeconds, onTimeout]);

    return timer;
};

export default useAutoTimeout;